<div class="pdf-preview-modal">
  <!-- Header -->
  <div class="modal-header">
    <div class="header-content">
      <h3 class="modal-title" tabindex="-1" cdkFocusInitial>{{ fileName }}</h3>
      <div class="page-info" *ngIf="totalPages > 0">
        Página {{ page }} de {{ totalPages }}
      </div>
    </div>
    <button class="btn-close" (click)="closeDialog()" aria-label="Cerrar visor PDF">
      <i class="fas fa-times"></i>
    </button>
  </div>

  <!-- Controles -->
  <div class="modal-controls">
    <div class="controls-group">
      <button 
        class="btn-control" 
        (click)="previousPage()" 
        [disabled]="page <= 1"
        aria-label="Página anterior">
        <i class="fas fa-chevron-left"></i>
        Anterior
      </button>
      <button 
        class="btn-control" 
        (click)="nextPage()" 
        [disabled]="page >= totalPages"
        aria-label="Página siguiente">
        Siguiente
        <i class="fas fa-chevron-right"></i>
      </button>
    </div>

    <div class="controls-group">
      <button 
        class="btn-control" 
        (click)="zoomOut()" 
        [disabled]="zoom <= 0.5"
        aria-label="Alejar">
        <i class="fas fa-search-minus"></i>
      </button>
      <span class="zoom-display">{{ (zoom * 100).toFixed(0) }}%</span>
      <button 
        class="btn-control" 
        (click)="zoomIn()" 
        [disabled]="zoom >= 2.0"
        aria-label="Acercar">
        <i class="fas fa-search-plus"></i>
      </button>
      <button 
        class="btn-control" 
        (click)="resetZoom()" 
        title="Restablecer zoom">
        <i class="fas fa-undo"></i>
      </button>
    </div>

    <div class="controls-group">
      <button 
        class="btn-control btn-download" 
        (click)="downloadPdf()"
        aria-label="Descargar PDF">
        <i class="fas fa-download"></i>
        Descargar
      </button>
    </div>
  </div>

  <!-- Visor PDF -->
  <div class="pdf-viewer-container">
    <pdf-viewer
      [src]="pdfSrc"
      [page]="page"
      [zoom]="zoom"
      [original-size]="false"
      [show-all]="false"
      [render-text]="true"
      (after-load-complete)="onLoadComplete($event)"
      style="display: block; width: 100%; height: 100%;">
    </pdf-viewer>
  </div>
</div>

